module.exports = __webpack_public_path__ + "img/loading.c6c28db3.gif";